import AngularOscillationAnimation from "../../../animations/AngularOscillationAnimation";
import SwapSprite from "../../../../../../../src/animation/SwapSprite";
import CalculationLine from "../../../entities/CalculationLine";
import SupplAngleLine from "../../../entities/SupplAngleLine";


export function showCalcLine(calcLine: CalculationLine): Promise<void> {
  const onUpdate = (v: number) => calcLine.scale.set(v);
  calcLine.visible = true;
  onUpdate(.4);
  return new Promise(() => new SwapSprite(.4, 1, (v: number) => onUpdate(v)))
}
export function showSuppleAngleLine(supplAngleLine: SupplAngleLine): Promise<void> {
  const onUpdate = (v: number) => supplAngleLine.scale.set(v);
  supplAngleLine.visible = true;
  onUpdate(.4)
  return new Promise(() => new SwapSprite(.4, 1, (v: number) => onUpdate(v)))
}
export function drawAnglrOscilAnim(startRadian: number, callback: (a: number) => void): Promise<void> {
  return new Promise((resolve) => {
    new AngularOscillationAnimation(startRadian, callback, resolve, resolve);
  })
}
